import React from "react";
import {ConnectedRouter} from "react-router-redux";
import {Provider} from "react-redux";
import {Route, Switch} from "react-router-dom";
// import {applyMiddleware } from 'redux';
// import promise from 'redux-promise';

import "assets/vendors/style";
import "styles/flexile.less";
import configureStore, {history} from "./appRedux/store";
import App from "./containers/App/index";


export const store = configureStore();
// export const storeWithMiddleware = applyMiddleware(promise)(store);

const NextApp = () =>
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/" component={App}/>
      </Switch>
    </ConnectedRouter>
  </Provider>;


export default NextApp;



// WEBPACK FOOTER //
// ./src/NextApp.js